import { Component } from '@angular/core';

@Component({
  selector: 'app-programme-about',
  templateUrl: './programme-about.component.html',
  styleUrls: ['./programme-about.component.scss']
})
export class ProgrammeAboutComponent {

}
